import { filter, trim } from "lodash";
import { isDefaultLang } from "./is-default-lang";
export var entityLangPath = function (entity, lang) {
  var basePath = trim((entity.path || '/').replace(/^\/[a-z][a-z]\//, ''), '/');
  var paths = [basePath];
  if (!isDefaultLang(lang)) {
    paths.unshift(trim(lang.path, '/'));
  }
  return "/".concat(filter(paths).join('/'));
};